// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import OddsTravelOptionManagerContainer from '../../modules/animations/containers/OddsTravelOptionManagerContainer';
import colors from '../../styled-components/palette';
import DisplayBetSlidersOptionContainer from '../DisplayBetSlidersOption/DisplayBetSlidersOptionContainer';
import ListItem, { ListWrapper } from '../ListItem';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0.5em;
`;

const Title = styled.div`
  font-size: 1.4em;
  margin: 0.5em 0 1em 0.6em;
  color: #fff;
`;

const StyledListItem = styled(ListItem)`
  padding: 0.75em 1em;
  color: #fff;
  background: ${colors.bluegrey900};

  display: flex;
  justify-content: space-between;
  border: 0;

  &:not(:last-child)::after {
    content: '';
    background: ${colors.bluegrey800};
    bottom: 0;
    height: 1px;
    left: 1em;
    position: absolute;
    right: 1em;
  }
`;

const UserAccountGraphicsPreferences = () => {
  return (
    <Wrapper>
      <Title>{__('Graphics preferences')}</Title>
      <ListWrapper $border>
        <StyledListItem>
          <OddsTravelOptionManagerContainer />
        </StyledListItem>
        <StyledListItem>
          <DisplayBetSlidersOptionContainer />
        </StyledListItem>
      </ListWrapper>
    </Wrapper>
  );
};

export default UserAccountGraphicsPreferences;
